import pgaData from '@/pga-data.json'

export const getPgaColor  = (key : string) =>{
    for( let i = 0; i< pgaData.length; i++){
        if( pgaData[i]['tariffFlagCode'] === key){
            if(pgaData[i]['agencyCodeType'] === "M"){
                return "yellow"
            }else if(pgaData[i]['agencyCodeType'] === "R" ){
                return "red"
            }
        }
    }
    return "yellow"
}